import Vue from "vue";
import App from "./App.vue";
import { router } from "./router";
import store from "./store";
import * as echarts from "echarts";
import "./assets/styles/common.less";
import "./assets/iconfont/iconfont.css";
import "./assets/icons"; // icon
import "./plugins/elementUI";
import { VueJsonp } from "vue-jsonp";
import plugins from "./plugins"; // plugins
import Print from 'vue-print-nb';
import VueAwesomeSwiper from "vue-awesome-swiper";
import "swiper/swiper-bundle.css";
import VueCoreVideoPlayer from 'vue-core-video-player'
import VideoPlayer from "vue-video-player";
import "video.js/dist/video-js.css";
import "vue-video-player/src/custom-theme.css";

// 路由导航守卫
import "./routerPermission.js";
import { projectFileUrl } from "@/config";
import {
  parseTime, resetForm, addDateRange,
  selectDictLabel, filterStreetByDistrictId,
  handleStringSplitArray, handleArrayJoinString,
  handleTree, handleObject, checkDisabledOption,
  getObjType, deepClone, handleQueryType
} from "@/utils/datahome";
// 头部标签组件
import VueMeta from "vue-meta";
// 自定义表格工具组件
import RightToolbar from "@/components/rightToolbar";
// 分页组件
import Pagination from "@/components/pagination";
// tag标签组件
import DictTag from '@/components/dictTag';
// text标签组件
import DictText from '@/components/dictText';
// 自定义select下拉内容组件
import CustomOption from '@/components/customOption';
import CustomOptionStatus from '@/components/customOptionByStatus';
// 表格和可视化切换组件
import SwitchTab from "@/components/customSwitchTab";
// 自定义表格
import CustomTable from "@/components/customTable";
import PreviewItem from "@/components/previewItem";
// 自定义链接跳转
import CustomRouterLink from "@/components/customRouterLink";

import importDirective from "@/directive";
import applyFormData from './libs/applyFormData.js'
importDirective(Vue);

import ElFormReInitialValuePatch from '@/components/elFormreInitialValue/elFormreInitialValue.js'
Vue.use(ElFormReInitialValuePatch)

Vue.use(VueAwesomeSwiper, /* { default options with global component } */);
Vue.use(VueCoreVideoPlayer)
Vue.use(VideoPlayer)

// 全局组件挂载
Vue.component("RightToolbar", RightToolbar);
Vue.component("Pagination", Pagination);
Vue.component("DictTag", DictTag);
Vue.component("DictText", DictText);
Vue.component("CustomOption", CustomOption);
Vue.component("CustomOptionStatus", CustomOptionStatus);
Vue.component("SwitchTab", SwitchTab);
Vue.component("CustomTable", CustomTable);
Vue.component("PreviewItem", PreviewItem);
Vue.component("CustomRouterLink", CustomRouterLink);

Vue.use(VueMeta);
Vue.use(plugins);
Vue.use(VueJsonp);
Vue.use(Print);

import VCalendar from 'v-calendar'; // 引入日历插件

Vue.use(VCalendar, {
  componentPrefix: 'vc',
});

// 全局方法挂载
Vue.config.productionTip = false;
Vue.prototype.$maxFileSize = 50 * 1024 * 1024;
Vue.prototype.$echarts = echarts;
Vue.prototype.parseTime = parseTime;
Vue.prototype.resetForm = resetForm;
Vue.prototype.addDateRange = addDateRange;
Vue.prototype.selectDictLabel = selectDictLabel;
Vue.prototype.filterStreetByDistrictId = filterStreetByDistrictId;
Vue.prototype.handleStringSplitArray = handleStringSplitArray;
Vue.prototype.handleArrayJoinString = handleArrayJoinString;
Vue.prototype.handleTree = handleTree;
Vue.prototype.handleObject = handleObject;
Vue.prototype.checkDisabledOption = checkDisabledOption;
Vue.prototype.applyFormData = applyFormData;
Vue.prototype.getObjType = getObjType;
Vue.prototype.deepClone = deepClone;
Vue.prototype.handleQueryType = handleQueryType;
Vue.prototype.projectFileUrl = projectFileUrl;

//弹出框禁止滑动
Vue.prototype.stopScroll = function () {
  let mo = function (e) { e.preventDefault() };
  document.body.style.overflow = 'hidden';
  document.addEventListener('touchmove', mo, false);
}

//弹出框可以滑动
Vue.prototype.canScroll = function () {
  let mo = function (e) { e.preventDefault() };
  document.body.style.overflow = ''; // 出现滚动条
  document.removeEventListener('touchmove', mo, false);
}

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
